export const DISABLE_FORMSAVENOTIFIER_INC = 'DISABLE_FORMSAVENOTIFIER_INCREMENT';
export const DISABLE_FORMSAVENOTIFIER_DEC = 'DISABLE_FORMSAVENOTIFIER_DECREMENT';
